export type SpoofBanner = 'private' | 'customerVisible' | null

interface SelectSpoofBannerParams {
  isSpoofed: boolean
  hiddenFromCustomer: boolean
  chatExists: boolean
}

export function selectSpoofBanner({ isSpoofed, hiddenFromCustomer, chatExists }: SelectSpoofBannerParams): SpoofBanner {
  if (!isSpoofed) return null
  // A new (not-yet-persisted) spoofed chat WILL be created hidden -> treat as private (Arch-2A).
  if (!chatExists || hiddenFromCustomer) return 'private'
  return 'customerVisible'
}
